import { createReducer } from 'typesafe-actions'
import { BuildabilityStatus } from '../../entities/BuildabilityStatus'
import {
    addConfigurationBuildabilityStatus,
    resetConfigurationBuildabilityStatuses,
} from '../actions/app/configuration.actions'

export type ConfigurationBuildabilityState = {
    [configurationString: string]: BuildabilityStatus
}

export const defaultState: ConfigurationBuildabilityState = {}

const configurationBuildabilityReducer = createReducer(defaultState)
    .handleAction(addConfigurationBuildabilityStatus, (state, action) => {
        return {
            ...state,
            [action.payload.configurationString]: action.payload.status,
        }
    })
    .handleAction(resetConfigurationBuildabilityStatuses, () => defaultState)

export default configurationBuildabilityReducer
